const mixin = {
    props: {
        modelValue: {
            default: null,
            //type: String | Number,
        },
        placeholder: {
            default: '',
            type: String,
        },
        /*name: {
            default: null,
            type: String,
        },*/
        store: {
            default: null,
            type: String,
        },
        disabled: {
            default: false
        }
    },
    computed: {
        id() {
            return this.$parent.uid
        },
        label() {
            return this.$parent.label
        },
        textHelp() {
            return this.$parent.textHelp
        },
        name() {
            return this.$parent.name
        },
        required() {
            return this.$parent.required
        },
    }

};

import {ref, watch, computed, getCurrentInstance} from 'vue'
import {useStore} from 'vuex'

const setup = (props) => {

    const _this = getCurrentInstance();
    const _parent = _this.parent;
    const name = _parent.props.name;
    const form = _parent.parent;
    const store = form.props.store;

    const exp = {};
    exp.id2 = computed(() => _parent.uid)
   // console.log('🤠', _parent)


    if (store && name) {
        //console.log(`${name} => store ${store + '/' + name}`)
        const _store = useStore()
        exp.value = computed(() => _store.getters[store + '/' + name])

        exp.input = (event) => {
            let value;
            if (event === Object(event)) {
                value = event.target ? event.target.value?.trim() : {...event};
            } else {
                value = event
            }

            //console.log('input:', value);
            _store.commit(store + '/setField',
                {field: name, value})
        }

    } else {
        exp.value = ref(props.modelValue)

        watch(() => props.modelValue, () => {
            /*
             exp.value = props.modelValue === Object(props.modelValue) ? {...props.modelValue} : props.modelValue;
            console.log(exp.value)
             */

            exp.value = props.modelValue;
        })
        exp.input = (event) => {

            let value;
            if (event === Object(event)) {
                value = event.target ? event.target.value?.trim() : {...event};
            } else {
                value = event
            }
            //console.log('input:', value)
            _this.emit('update:modelValue', value);
        }
    }

    return exp
}
export {
    setup, mixin
}